var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('search-card',{staticClass:"mb-4",attrs:{"search":_vm.search}}),_c('search-driver',{attrs:{"search":_vm.search}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }